import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import MultiCategory from '../entities/multiCategory'
import Cascader from '../entities/cascader'
import Ajax from '@/lib/ajax'
import PageResult from '@/store/entities/page-result';
import ClassificationType from '../entities/classificationType'

interface MultiCategoryState extends ListState<MultiCategory> {
    editMultiCategory: MultiCategory;
    cascaders: any;
    classificationTypes: any;
    chapterCascader: any;
    behindCascaders: any;
}
class MultiCategoryModule extends ListModule<MultiCategoryState, any, MultiCategory>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<MultiCategory>(),
        loading: false,
        editMultiCategory: new MultiCategory(),
        cascaders: new Array<Cascader>(),
        behindCascaders: new Array<Cascader>(),
        classificationTypes: new Array<ClassificationType>(),
        chapterCascader: new Array<Cascader>()
    }
    actions = {
        async getAll(context: ActionContext<MultiCategoryState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/MultiLevelCategory/GetAll', { params: payload.data });
            context.state.loading = false;
            let page = reponse.data.result as PageResult<MultiCategory>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
        async getAllChapterTypeSetting(context: ActionContext<MultiCategoryState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/MultiLevelCategory/GetAllChapterTypeSetting', { params: payload.data });
            context.state.loading = false;
            let page = reponse.data.result as PageResult<MultiCategory>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
        async create(context: ActionContext<MultiCategoryState, any>, payload: any) {
            await Ajax.post('/api/services/app/MultiLevelCategory/Create', payload.data);
        },
        async update(context: ActionContext<MultiCategoryState, any>, payload: any) {
            await Ajax.put('/api/services/app/MultiLevelCategory/Update', payload.data);
        },
        async delete(context: ActionContext<MultiCategoryState, any>, payload: any) {
            await Ajax.delete('/api/services/app/MultiLevelCategory/Delete?Id=' + payload.data.id);
        },
        async get(context: ActionContext<MultiCategoryState, any>, payload: any) {
            let reponse = await Ajax.get('/api/services/app/MultiLevelCategory/Get?Id=' + payload.id);
            return reponse.data.result as MultiCategory;
        },
        async getSameLevelBreadCrumbs(context: ActionContext<MultiCategoryState, any>, payload: any) {
            let reponse = await Ajax.get('/api/services/app/MultiLevelCategory/GetSameLevelBreadCrumbs?Id=' + payload.id);
            return reponse.data.result;
        },

        async getQuestionStatistical(context: ActionContext<MultiCategoryState, any>, payload: any) {
            let reponse = await Ajax.get('/api/services/app/TestQuestion/GetQuestionStatistical?SectionId=' + payload.id);
            return reponse.data.result;
        },


        async getCascader(context: ActionContext<MultiCategoryState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/MultiLevelCategory/GetCascaderList', { params: payload.data });
            context.state.cascaders = reponse.data.result as Array<Cascader>;
        },
        async getBehindCascader(context: ActionContext<MultiCategoryState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/MultiLevelCategory/GetBehindCascaderList', { params: payload.data });
            context.state.behindCascaders = reponse.data.result as Array<Cascader>;
        },
        async getClassificationType(context: ActionContext<MultiCategoryState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/ClassificationType/GetClassificationTypeList', { params: payload.data });
            context.state.classificationTypes = reponse.data.result as Array<ClassificationType>;
        },
        async getChapterCascaderList(context: ActionContext<MultiCategoryState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/MultiLevelCategory/GetChapterCascaderList', { params: payload.data });
            context.state.chapterCascader = reponse.data.result as Array<Cascader>;
        },
        async getCascaderEvery(context: ActionContext<MultiCategoryState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/MultiLevelCategory/GetCascaderList', { params: payload.data });
            return reponse.data.result as Array<Cascader>;
        }, async getCascaderEveryType(context: ActionContext<MultiCategoryState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/MultiLevelCategory/GetCascaderWebsiteList', { params: payload.data });
            return reponse.data.result as Array<Cascader>;
        },

        async getCascaderWebsiteList(context: ActionContext<MultiCategoryState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/MultiLevelCategory/GetCascaderWebsiteList', { params: payload.data });
            return reponse.data.result
        },
        async getCascaderSchool() {
            let reponse = await Ajax.get('/api/services/app/MultiLevelCategory/GetCascaderSchool');
            return reponse.data.result as Array<Cascader>;
        }
    };
    mutations = {
        setCurrentPage(state: MultiCategoryState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: MultiCategoryState, pagesize: number) {
            state.pageSize = pagesize;
        },
        edit(state: MultiCategoryState, multiCategory: MultiCategory) {
            state.editMultiCategory = multiCategory;
        }
    }
}
const multiCategoryModule = new MultiCategoryModule();
export default multiCategoryModule;